import { cn } from '@/utils/helpers';

export type UploadIconProps = {
  className?: string;
};

/** Arrow up from tray — attach / upload menu (Figma). */
export function UploadIcon({ className }: UploadIconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      className={cn('upload-icon', className)}
      aria-hidden
    >
      <path
        d="M9 11.25V3.75M9 3.75L6 6.75M9 3.75L12 6.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 11.25V13.5C3.75 14.3284 4.42157 15 5.25 15H12.75C13.5784 15 14.25 14.3284 14.25 13.5V11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
